import iBS03TP_ResultType from '../model/iBS03TP_ResultType';
import SensorResultTable from './SensorResultTable';

type propsType = {
    sensorlogs: iBS03TP_ResultType[]
}

const COLUMNS = ["no", "app_id", "manufacturer_id", "model", "battery", "button", "moving", "hall_sensor", "temperature", "probe_temperature", "macaddress", "rssi", "detected", "arrived"];

const SensorLog_iBS03TP_Result = (props: propsType) => (
    <SensorResultTable rows={props.sensorlogs} columnKeys={COLUMNS} />
);

export default SensorLog_iBS03TP_Result;
